import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { getPackageTrackingDetails } from '../../store/actions/batch.action';
import Modal from "react-bootstrap/Modal";
import LoaderSpinner from '../common/Loader';
import './tracking.css';
import moment from 'moment';

/* istanbul ignore next */
const TrackingDetails = (props) => {
    const { trackingNumber, item, ...modalProps } = props;
    const [showLoader, setShowLoader] = React.useState(false);
    const [trackingResponse, setTrackingResponse] = React.useState({});
    const [errorDetails, setErrorDetails] = React.useState({show: false, message: ''});
    
    useEffect(() => {
        fetchTrackingDetails();
    }, [trackingNumber]);

    const fetchTrackingDetails = async () => {
      let trackingDetails = {
        trackingNumber: trackingNumber,
      };
      setShowLoader(true);
      let res = await getPackageTrackingDetails(trackingDetails);
      if(res.data.Status === 200){
        setTrackingResponse(res.data.Entity);
        setErrorDetails({show: false, message: ''});
      } else {
        setErrorDetails({show: true, message: res.data.Message.AppStatusDescription });
      }
      setShowLoader(false);
    }

    return (
      <Modal {...modalProps} className="modalDeleteWrapper" size="lg">
              <Modal.Header closeButton>
                <div className="modal-main-div">
                  <span className="modal-m-text"> Tracking History {showLoader && <LoaderSpinner />}</span>
                </div>
              </Modal.Header>
              <Modal.Body className="fontFix trackingModal">
                <div className='mb-1'>
                    <div className='heading mb-1'>Tracking: {trackingNumber}</div>
                    <div>{item?.ReceiverName}</div>
                    <div>{item?.ReceiverAddressLine1}</div>
                    <div>{item?.ReceiverAddressLine2}</div>
                    <div>{item?.ReceiverAddressLine3}</div>
                    <div>{item?.ReceiverCity} {item?.ReceiverState} {item?.ReceiverZip} {item?.CountryCode}</div>
                </div>
                <div className="trackingBox pt-1">
                  <div className="timeline">
                    {trackingResponse?.trackingEvents?.map((event, index) => (
                      <div className={`timeline-item ${event.eventType.includes('Delivered') ? 'delivered' : ''}`} key={index}> {/* NOSONAR */}
                        <div className="status">{event.eventType}</div>
                        <div className="sub-status">{event.subStatus}</div>
                        <div className="location">{event.eventCity} {event.eventState} {event.eventZIP}</div>
                        <div className="date">{event.eventTimestamp && moment(event.eventTimestamp).format('MMMM D, YYYY, h:mm a')}</div>
                      </div>
                    ))}

                  </div>
              </div>
                    {errorDetails.show && (
                      <div className="error-message tracking">{errorDetails.message}</div>
                    )}
              </Modal.Body>
            </Modal>  
    );
}

TrackingDetails.propTypes = {
    trackingNumber: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired
};

export default TrackingDetails;